import { useTranslation } from 'react-i18next';
import { Input } from '@/components/ui/input';
import type { RagConfig } from '@/api/types';
import { Field, FormShell } from './shared';

interface Props {
  initial: RagConfig | null;
  onSubmit: (config: Partial<RagConfig>) => void;
  submitting: boolean;
  onCancel: () => void;
  onReset?: () => void;
}

export function RagForm({ initial, onSubmit, submitting, onCancel, onReset }: Props): JSX.Element {
  const { t } = useTranslation();

  return (
    <form
      id="integration-form"
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit({});
      }}
    >
      <FormShell submitting={submitting} onCancel={onCancel} onReset={onReset}>
        <p className="text-sm text-muted-foreground">{t('integrations.form.rag.autoProvision')}</p>
        {initial ? (
          <>
            <Field label={t('integrations.form.rag.status')} htmlFor="rag-status">
              <Input id="rag-status" value={t(`integrations.form.rag.statuses.${initial.status}`)} disabled />
            </Field>
            {initial.knowledgeBaseId ? (
              <Field label={t('integrations.form.rag.knowledgeBaseId')} htmlFor="rag-kb">
                <Input id="rag-kb" value={initial.knowledgeBaseId} disabled className="font-mono" />
              </Field>
            ) : null}
            {initial.error ? (
              <p className="font-mono text-xs text-destructive">{initial.error}</p>
            ) : null}
          </>
        ) : null}
      </FormShell>
    </form>
  );
}
